export default "__VITE_ASSET__De4RFl4S__"